import React from "react";
import "./Navigationdowen.css";

import logo from "../img/logooo.png";
import insta from "../img2/instagram.png";
import phone from "../img/phone.png";
import whatsapp from "../img2/whatsapp.png";
import mail from "../img2/gmail.png";

const Navigationdowen = () => {
  return (
    <footer className="footer">

      {/* LOGO */}
      <div className="footer-logo">
        <img src={logo} alt="logo" />
        <p>בניית אתרים לעסקים</p>
      </div>

      {/* ICONS */}
      <div className="footer-icons">
<a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=haivaizman87@gmail.com"
  target="_blank"
  rel="noreferrer"
  className="icon"
>
  <img src={mail} alt="mail" />
  <span>אימייל</span>
</a>

        <a href="https://www.instagram.com/hai_waizman/" className="icon" target="_blank" rel="noreferrer">
          <img src={insta} alt="instagram" />
          <span>אינסטגרם</span>
        </a>

        <a href="tel:0506831839" className="icon">
          <img src={phone} alt="phone" />
          <span>טלפון</span>
        </a>

        <a href="https://wa.me/972506831839" className="icon" target="_blank" rel="noreferrer">
          <img src={whatsapp} alt="whatsapp" />
          <span>וואטסאפ</span>
        </a>

      </div>

      <div className="footer-bottom">
        siteb2b© כל הזכויות שמורות | אתר נבנה על ידי siteb2b
      </div>

    </footer>
  );
};

export default Navigationdowen;